import {
  PopoverMenuCell_default
} from "./chunk-6C4TPXSN.mjs";
import "./chunk-GD6E42CP.mjs";
import {
  getBasketFromLocalStorage,
  saveBasketToLocalStorage
} from "./chunk-S6DMGQP5.mjs";
import {
  getItemParams
} from "./chunk-JYXW2UNX.mjs";
import {
  generateProductItemUrl
} from "./chunk-XV7TMGN6.mjs";
import {
  ShareLinkButton
} from "./chunk-BARDMAFJ.mjs";

// src/ProductsTable/ProductsTable.tsx
import { useEffect as useEffect4, useRef as useRef2, useState as useState5 } from "react";
import Alert from "@mui/material/Alert/index.js";
import Box8 from "@mui/material/Box/index.js";
import Paper from "@mui/material/Paper/index.js";
import Snackbar from "@mui/material/Snackbar/index.js";
import Table from "@mui/material/Table/index.js";
import TableBody from "@mui/material/TableBody/index.js";
import TableContainer from "@mui/material/TableContainer/index.js";
import TablePagination from "@mui/material/TablePagination/index.js";
import Typography8 from "@mui/material/Typography/index.js";
import { useTheme } from "@mui/material/styles/index.js";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

// src/ProductsTable/AdvancedRow.tsx
import Box4 from "@mui/material/Box/index.js";
import TableCell2 from "@mui/material/TableCell/index.js";
import TableRow from "@mui/material/TableRow/index.js";
import Typography4 from "@mui/material/Typography/index.js";

// src/ProductsTable/CertificatesDocsCell.tsx
import Badge from "@mui/material/Badge/index.js";
import Box2 from "@mui/material/Box/index.js";
import IconButton from "@mui/material/IconButton/index.js";
import Typography2 from "@mui/material/Typography/index.js";
import FileDownloadIcon2 from "@mui/icons-material/esm/FileDownload.js";

// src/ProductsTable/CertificateLinkList.tsx
import Box from "@mui/material/Box/index.js";
import Link from "@mui/material/Link/index.js";
import Typography from "@mui/material/Typography/index.js";
import FileDownloadIcon from "@mui/icons-material/esm/FileDownload.js";
import { jsx, jsxs } from "react/jsx-runtime";
var CertificateLinkList = ({ title, links, newTab }) => /* @__PURE__ */ jsxs(Box, { children: [
  /* @__PURE__ */ jsxs(
    Typography,
    {
      sx: {
        display: "flex",
        fontSize: { xs: "0.8rem", sm: "0.875rem" },
        color: "text.primary",
        fontWeight: 500,
        alignItems: "center",
        marginBottom: 1
      },
      children: [
        /* @__PURE__ */ jsx(
          FileDownloadIcon,
          {
            sx: { fontSize: { xs: "1rem", sm: "1.25rem" }, marginRight: "8px" }
          }
        ),
        title
      ]
    }
  ),
  /* @__PURE__ */ jsx(Box, { sx: { display: "flex", flexWrap: "wrap", gap: 1 }, children: links.map((link) => /* @__PURE__ */ jsx(
    Link,
    {
      href: link.src,
      target: newTab ? "_blank" : void 0,
      rel: newTab ? "noopener noreferrer" : void 0,
      sx: {
        display: "flex",
        alignItems: "center",
        padding: { xs: "4px 8px", sm: "6px 10px" },
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        borderRadius: "8px",
        color: "primary.main",
        textDecoration: "none",
        fontSize: { xs: "0.8rem", sm: "0.875rem" },
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          textDecoration: "underline"
        }
      },
      children: link.label
    },
    link.label
  )) })
] });
var CertificateLinkList_default = CertificateLinkList;

// src/ProductsTable/CertificatesDocsCell.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var CertificatesDocsCell = ({
  certificates,
  dataSheets
}) => {
  const total = certificates.length + dataSheets.length;
  if (total === 0) {
    return /* @__PURE__ */ jsx2(Typography2, { variant: "body2", sx: { color: "text.disabled" }, children: "-" });
  }
  return /* @__PURE__ */ jsx2(
    PopoverMenuCell_default,
    {
      ariaLabel: `Certificates and documentation (${total})`,
      trigger: ({ onClick }) => /* @__PURE__ */ jsx2(
        IconButton,
        {
          size: "small",
          onClick,
          sx: { color: "primary.main" },
          children: /* @__PURE__ */ jsx2(Badge, { badgeContent: total, color: "primary", children: /* @__PURE__ */ jsx2(FileDownloadIcon2, { fontSize: "small" }) })
        }
      ),
      children: /* @__PURE__ */ jsxs2(Box2, { sx: { display: "flex", flexDirection: "column", gap: 2 }, children: [
        certificates.length > 0 && /* @__PURE__ */ jsx2(
          CertificateLinkList_default,
          {
            title: "Certificates",
            links: certificates,
            newTab: true
          }
        ),
        dataSheets.length > 0 && /* @__PURE__ */ jsx2(CertificateLinkList_default, { title: "Data Sheets", links: dataSheets, newTab: true })
      ] })
    }
  );
};
var CertificatesDocsCell_default = CertificatesDocsCell;

// src/ProductsTable/RowActionsCell.tsx
import Box3 from "@mui/material/Box/index.js";
import TableCell from "@mui/material/TableCell/index.js";
import Typography3 from "@mui/material/Typography/index.js";

// src/ProductsTable/rowStyles.ts
var BORDER_COLOR = "rgba(224, 224, 224, 0.8)";
var STICKY_SHADOW_LEFT = "4px 0 6px -4px rgba(0, 0, 0, 0.25)";
var STICKY_SHADOW_RIGHT = "-4px 0 6px -4px rgba(0, 0, 0, 0.25)";
var ADVANCED_COLUMN_MAX_WIDTH = { xs: 64, sm: 88 };
var getRowBgColor = (item, isActiveRow, basket) => basket[item.itemcode] ? "primary.light" : isActiveRow ? "alternate.main" : "alternate.dark";
var sortLabelSx = {
  position: "relative",
  display: "inline-flex",
  justifyContent: "center",
  "&.MuiTableSortLabel-active": {
    color: "primary.main",
    "& .MuiTableSortLabel-icon": { color: "primary.main" }
  },
  "& .MuiTableSortLabel-icon": {
    position: "absolute",
    top: "50%",
    right: "-18px",
    margin: 0
  },
  "& .MuiTableSortLabel-iconDirectionAsc": {
    transform: "translateY(-50%) rotate(180deg)"
  },
  "& .MuiTableSortLabel-iconDirectionDesc": {
    transform: "translateY(-50%) rotate(0deg)"
  }
};

// src/ProductsTable/RowActionsCell.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var RowActionsCell = ({
  bgColor,
  inBasket,
  onToggleQuote,
  getShareUrl
}) => /* @__PURE__ */ jsx3(
  TableCell,
  {
    sx: {
      position: "sticky",
      right: 0,
      zIndex: 2,
      bgcolor: bgColor,
      borderLeft: `1px solid ${BORDER_COLOR}`,
      boxShadow: STICKY_SHADOW_RIGHT,
      width: { xs: "120px", sm: "160px" },
      minHeight: "60px",
      padding: { xs: "4px", sm: "8px" },
      transition: "background-color 0.2s ease"
    },
    children: /* @__PURE__ */ jsxs3(
      Box3,
      {
        sx: {
          display: "flex",
          flexDirection: { xs: "column", sm: "column" },
          alignItems: "center",
          gap: { xs: 0.25, sm: 0.5 },
          height: "100%",
          justifyContent: "center",
          transition: "all 0.2s ease"
        },
        children: [
          /* @__PURE__ */ jsx3(
            Typography3,
            {
              color: "primary",
              variant: "caption",
              fontWeight: 700,
              sx: {
                cursor: "pointer",
                fontSize: { xs: "0.65rem", sm: "0.75rem" },
                padding: { xs: "2px 4px", sm: "4px 8px" },
                borderRadius: "4px",
                transition: "all 0.2s ease",
                "&:hover": { bgcolor: "rgba(25, 118, 210, 0.08)" },
                textAlign: "center",
                lineHeight: 1.2
              },
              onClick: onToggleQuote,
              children: inBasket ? "Remove From Quote" : "Add To Quote"
            }
          ),
          /* @__PURE__ */ jsx3(
            ShareLinkButton,
            {
              tooltip: "Share product link",
              getUrl: getShareUrl,
              sx: {
                color: "primary.main",
                padding: { xs: "2px", sm: "4px" },
                "&:hover": { bgcolor: "rgba(25, 118, 210, 0.08)" }
              }
            }
          )
        ]
      }
    )
  }
);
var RowActionsCell_default = RowActionsCell;

// src/ProductsTable/AdvancedRow.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var AdvancedRow = ({
  item,
  visibleColumns,
  basket,
  isHighlighted,
  onToggleQuote,
  getShareUrl
}) => {
  const bgColor = getRowBgColor(item, isHighlighted, basket);
  const inBasket = Boolean(basket[item.itemcode]);
  const itemDetails = getItemParams(item);
  return /* @__PURE__ */ jsxs4(
    TableRow,
    {
      sx: {
        transition: "all 0.2s ease",
        "&:last-child td, &:last-child th": { borderBottom: 0 },
        bgcolor: bgColor,
        backgroundImage: inBasket ? "linear-gradient(90deg, rgba(220, 240, 255, 0.5) 0%, rgba(180, 210, 255, 0.3) 100%)" : "none",
        "&:hover": {
          bgcolor: inBasket ? "primary.light" : "rgba(0, 0, 0, 0.02)"
        }
      },
      children: [
        /* @__PURE__ */ jsx4(
          TableCell2,
          {
            align: "center",
            component: "th",
            scope: "row",
            sx: {
              position: "sticky",
              left: 0,
              zIndex: 2,
              bgcolor: bgColor,
              borderRight: `1px solid ${BORDER_COLOR}`,
              boxShadow: STICKY_SHADOW_LEFT,
              padding: { xs: "8px 4px", sm: "16px 12px" },
              minWidth: { xs: "64px", sm: "90px" },
              transition: "background-color 0.2s ease"
            },
            children: /* @__PURE__ */ jsxs4(
              Box4,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 0.25
                },
                children: [
                  /* @__PURE__ */ jsx4(
                    Typography4,
                    {
                      variant: "subtitle2",
                      fontWeight: 700,
                      sx: {
                        color: "text.primary",
                        fontSize: { xs: "0.75rem", sm: "0.875rem" }
                      },
                      children: itemDetails.PartNumber ?? "-"
                    }
                  ),
                  /* @__PURE__ */ jsx4(
                    Typography4,
                    {
                      variant: "caption",
                      fontWeight: 400,
                      sx: {
                        color: "text.secondary",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" }
                      },
                      children: item.itemcode
                    }
                  )
                ]
              }
            )
          }
        ),
        visibleColumns.map((column) => /* @__PURE__ */ jsx4(
          TableCell2,
          {
            align: "center",
            component: "th",
            scope: "row",
            sx: {
              borderRight: `1px solid ${BORDER_COLOR}`,
              padding: { xs: "8px 4px", sm: "16px 12px" },
              maxWidth: ADVANCED_COLUMN_MAX_WIDTH,
              transition: "all 0.2s ease"
            },
            children: /* @__PURE__ */ jsx4(
              Typography4,
              {
                variant: "subtitle2",
                sx: {
                  color: "text.secondary",
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                  fontWeight: 500,
                  overflowWrap: "anywhere"
                },
                children: itemDetails.ParametersUI?.[column.name] ?? ""
              }
            )
          },
          column.name
        )),
        /* @__PURE__ */ jsx4(
          TableCell2,
          {
            align: "center",
            sx: {
              borderRight: `1px solid ${BORDER_COLOR}`,
              padding: { xs: "8px 4px", sm: "16px 12px" }
            },
            children: /* @__PURE__ */ jsx4(
              CertificatesDocsCell_default,
              {
                certificates: itemDetails.Certificates ?? [],
                dataSheets: itemDetails.DataSheets ?? []
              }
            )
          }
        ),
        /* @__PURE__ */ jsx4(
          RowActionsCell_default,
          {
            bgColor,
            inBasket,
            onToggleQuote: (event) => onToggleQuote(item, event),
            getShareUrl: () => getShareUrl(item)
          }
        )
      ]
    }
  );
};
var AdvancedRow_default = AdvancedRow;

// src/ProductsTable/AdvancedViewToggle.tsx
import Box5 from "@mui/material/Box/index.js";
import FormControlLabel from "@mui/material/FormControlLabel/index.js";
import Switch from "@mui/material/Switch/index.js";
import Tooltip from "@mui/material/Tooltip/index.js";
import { jsx as jsx5 } from "react/jsx-runtime";
var AdvancedViewToggle = ({ checked, onChange }) => /* @__PURE__ */ jsx5(
  Box5,
  {
    sx: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: 1
    },
    children: /* @__PURE__ */ jsx5(
      Tooltip,
      {
        title: "Show every specification in a dense table, with no click-to-expand",
        arrow: true,
        children: /* @__PURE__ */ jsx5(
          FormControlLabel,
          {
            control: /* @__PURE__ */ jsx5(
              Switch,
              {
                checked,
                onChange: (event) => onChange(event.target.checked),
                size: "small"
              }
            ),
            label: "Advanced view",
            labelPlacement: "start",
            sx: { marginRight: 0, color: "text.secondary" }
          }
        )
      }
    )
  }
);
var AdvancedViewToggle_default = AdvancedViewToggle;

// src/ProductsTable/BasicRow.tsx
import Box7 from "@mui/material/Box/index.js";
import Collapse from "@mui/material/Collapse/index.js";
import TableCell3 from "@mui/material/TableCell/index.js";
import TableRow2 from "@mui/material/TableRow/index.js";
import Typography6 from "@mui/material/Typography/index.js";

// src/ProductsTable/ProductDetailsPanel.tsx
import Box6 from "@mui/material/Box/index.js";
import Grid from "@mui/material/Grid/index.js";
import Typography5 from "@mui/material/Typography/index.js";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var renderFilterName = (name) => {
  if (!name) return name;
  return name.split(/(<sub>.*?<\/sub>)/g).map((part, index) => {
    if (part.startsWith("<sub>") && part.endsWith("</sub>")) {
      return /* @__PURE__ */ jsx6("sub", { children: part.replace(/<\/?sub>/g, "") }, index);
    }
    return part;
  });
};
var ProductDetailsPanel = ({ item, columns }) => {
  const itemDetails = getItemParams(item);
  const specColumns = columns.filter(
    (column) => itemDetails.ParametersUI?.[column.name] && itemDetails.ParametersUI[column.name] !== "No data"
  );
  return /* @__PURE__ */ jsx6(
    Box6,
    {
      sx: {
        padding: { xs: 2, sm: 3 },
        backgroundColor: "rgba(0, 0, 0, 0.02)"
      },
      children: /* @__PURE__ */ jsxs5(Grid, { container: true, spacing: { xs: 2, sm: 3 }, children: [
        /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, md: 3, children: /* @__PURE__ */ jsxs5(
          Box6,
          {
            sx: {
              height: "100%",
              backgroundColor: "white",
              borderRadius: { xs: "8px", sm: "12px" },
              padding: { xs: 2, sm: 3 },
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
            },
            children: [
              /* @__PURE__ */ jsx6(
                Typography5,
                {
                  variant: "subtitle1",
                  fontWeight: 600,
                  sx: {
                    color: "text.primary",
                    marginBottom: 2,
                    fontSize: { xs: "1rem", sm: "1.125rem" }
                  },
                  children: "Product Overview"
                }
              ),
              /* @__PURE__ */ jsx6(
                Typography5,
                {
                  variant: "body2",
                  sx: {
                    color: "text.primary",
                    fontWeight: 500,
                    lineHeight: 1.6,
                    marginBottom: 3,
                    fontSize: { xs: "0.875rem", sm: "1rem" }
                  },
                  children: itemDetails["Description"]
                }
              ),
              /* @__PURE__ */ jsx6(
                Box6,
                {
                  sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                    borderRadius: "8px",
                    padding: { xs: 1, sm: 2 },
                    minHeight: { xs: "150px", sm: "200px" }
                  },
                  children: /* @__PURE__ */ jsx6(
                    "img",
                    {
                      src: itemDetails["ImageUrl"] || "https://th.bing.com/th/id/OIP.gLIxUrBNj4TE3OEKt5N-2wHaGO?rs=1&pid=ImgDetMain",
                      alt: itemDetails["PartNumber"],
                      style: {
                        maxWidth: "100%",
                        maxHeight: window.innerWidth < 600 ? "150px" : "200px",
                        objectFit: "contain"
                      }
                    }
                  )
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, md: 9, children: /* @__PURE__ */ jsx6(
          Box6,
          {
            sx: {
              height: "100%",
              backgroundColor: "white",
              borderRadius: { xs: "8px", sm: "12px" },
              padding: { xs: 2, sm: 3 },
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)"
            },
            children: /* @__PURE__ */ jsxs5(Grid, { container: true, spacing: { xs: 1.5, sm: 2 }, children: [
              specColumns.map((column) => /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, sm: 6, md: 4, children: /* @__PURE__ */ jsxs5(
                Box6,
                {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    padding: { xs: "8px", sm: "0" },
                    backgroundColor: {
                      xs: "rgba(0, 0, 0, 0.02)",
                      sm: "transparent"
                    },
                    borderRadius: { xs: "4px", sm: "0" }
                  },
                  children: [
                    /* @__PURE__ */ jsx6(
                      Typography5,
                      {
                        sx: {
                          color: "text.secondary",
                          fontWeight: 500,
                          fontSize: { xs: "0.8rem", sm: "0.875rem" }
                        },
                        children: renderFilterName(column.name)
                      }
                    ),
                    /* @__PURE__ */ jsx6(
                      Typography5,
                      {
                        sx: {
                          color: "text.primary",
                          fontSize: { xs: "0.8rem", sm: "0.875rem" },
                          wordBreak: "break-word"
                        },
                        children: renderFilterName(
                          itemDetails.ParametersUI?.[column.name]
                        )
                      }
                    )
                  ]
                }
              ) }, column.name)),
              (itemDetails["Certificates"] || itemDetails["DataSheets"]) && /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx6(
                Box6,
                {
                  sx: {
                    borderTop: "1px solid rgba(0, 0, 0, 0.08)",
                    marginTop: { xs: 0.5, sm: 1 },
                    paddingTop: { xs: 1.5, sm: 2 }
                  }
                }
              ) }),
              itemDetails["Certificates"] && /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, sm: 6, children: /* @__PURE__ */ jsx6(
                CertificateLinkList_default,
                {
                  title: "Certificates",
                  links: itemDetails["Certificates"]
                }
              ) }),
              itemDetails["DataSheets"] && /* @__PURE__ */ jsx6(Grid, { item: true, xs: 12, sm: 6, children: /* @__PURE__ */ jsx6(
                CertificateLinkList_default,
                {
                  title: "Data Sheets",
                  links: itemDetails["DataSheets"],
                  newTab: true
                }
              ) })
            ] })
          }
        ) })
      ] })
    }
  );
};
var ProductDetailsPanel_default = ProductDetailsPanel;

// src/ProductsTable/BasicRow.tsx
import { Fragment, jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var BasicRow = ({
  item,
  rowIndex,
  visibleColumns,
  detailColumns,
  basket,
  isExpanded,
  onRowClick,
  onToggleQuote,
  getShareUrl
}) => {
  const bgColor = getRowBgColor(item, isExpanded, basket);
  const inBasket = Boolean(basket[item.itemcode]);
  return /* @__PURE__ */ jsxs6(Fragment, { children: [
    /* @__PURE__ */ jsxs6(
      TableRow2,
      {
        onClick: () => onRowClick(rowIndex),
        sx: {
          cursor: "pointer",
          transition: "all 0.2s ease",
          "&:last-child td, &:last-child th": { borderBottom: 0 },
          bgcolor: bgColor,
          backgroundImage: inBasket ? "linear-gradient(90deg, rgba(220, 240, 255, 0.5) 0%, rgba(180, 210, 255, 0.3) 100%)" : "none",
          "&:hover": {
            bgcolor: inBasket ? "primary.light" : "rgba(0, 0, 0, 0.02)"
          }
        },
        children: [
          /* @__PURE__ */ jsx7(
            TableCell3,
            {
              align: "center",
              component: "th",
              scope: "row",
              sx: {
                position: "sticky",
                left: 0,
                zIndex: 2,
                bgcolor: bgColor,
                borderRight: `1px solid ${BORDER_COLOR}`,
                boxShadow: STICKY_SHADOW_LEFT,
                padding: { xs: "8px 4px", sm: "16px 12px" },
                minWidth: { xs: "90px", sm: "140px" },
                transition: "background-color 0.2s ease"
              },
              children: /* @__PURE__ */ jsxs6(
                Box7,
                {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 0.25
                  },
                  children: [
                    /* @__PURE__ */ jsx7(
                      Typography6,
                      {
                        variant: "subtitle2",
                        fontWeight: 700,
                        sx: {
                          color: "text.primary",
                          fontSize: { xs: "0.75rem", sm: "0.875rem" }
                        },
                        children: getItemParams(item).PartNumber ?? "-"
                      }
                    ),
                    /* @__PURE__ */ jsx7(
                      Typography6,
                      {
                        variant: "caption",
                        fontWeight: 400,
                        sx: {
                          color: "text.secondary",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" }
                        },
                        children: item.itemcode
                      }
                    )
                  ]
                }
              )
            }
          ),
          visibleColumns.map((column) => /* @__PURE__ */ jsx7(
            TableCell3,
            {
              align: "center",
              component: "th",
              scope: "row",
              sx: {
                borderRight: `1px solid ${BORDER_COLOR}`,
                padding: { xs: "8px 4px", sm: "16px 12px" },
                transition: "all 0.2s ease"
              },
              children: /* @__PURE__ */ jsx7(
                Typography6,
                {
                  variant: "subtitle2",
                  sx: {
                    color: "text.secondary",
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    fontWeight: 500
                  },
                  children: getItemParams(item).ParametersUI?.[column.name] ?? ""
                }
              )
            },
            column.name
          )),
          /* @__PURE__ */ jsx7(
            RowActionsCell_default,
            {
              bgColor,
              inBasket,
              onToggleQuote: (event) => onToggleQuote(item, event),
              getShareUrl: () => getShareUrl(item)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx7(TableRow2, { sx: { display: isExpanded ? "table-row" : "none" }, children: /* @__PURE__ */ jsx7(
      TableCell3,
      {
        sx: {
          borderRight: `1px solid ${BORDER_COLOR}`,
          padding: 0,
          bgcolor: "rgba(0, 0, 0, 0.02)"
        },
        colSpan: visibleColumns.length + 2,
        children: /* @__PURE__ */ jsx7(Collapse, { in: isExpanded, timeout: "auto", unmountOnExit: true, children: /* @__PURE__ */ jsx7(ProductDetailsPanel_default, { item, columns: detailColumns }) })
      }
    ) })
  ] });
};
var BasicRow_default = BasicRow;

// src/ProductsTable/ProductsTableHead.tsx
import React from "react";
import TableCell4 from "@mui/material/TableCell/index.js";
import TableHead from "@mui/material/TableHead/index.js";
import TableRow3 from "@mui/material/TableRow/index.js";
import TableSortLabel from "@mui/material/TableSortLabel/index.js";
import Typography7 from "@mui/material/Typography/index.js";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var withWordBreaks = (text, keyPrefix) => text.split(/(?=[A-Z])/).filter(Boolean).map((segment, index) => /* @__PURE__ */ jsxs7(React.Fragment, { children: [
  index > 0 && /* @__PURE__ */ jsx8("wbr", {}),
  segment
] }, `${keyPrefix}-${index}`));
var renderFilterName2 = (name) => {
  return name.split(/(<sub>.*?<\/sub>)/g).map((part, index) => {
    if (part.startsWith("<sub>") && part.endsWith("</sub>")) {
      return /* @__PURE__ */ jsx8("sub", { children: part.replace(/<\/?sub>/g, "") }, index);
    }
    return /* @__PURE__ */ jsx8(React.Fragment, { children: withWordBreaks(part, `part-${index}`) }, index);
  });
};
var ProductsTableHead = ({
  visibleColumns,
  order,
  orderBy,
  onSortRequest,
  showDocsColumn,
  compact
}) => /* @__PURE__ */ jsx8(TableHead, { children: /* @__PURE__ */ jsxs7(
  TableRow3,
  {
    sx: {
      bgcolor: "alternate.main",
      "& th": {
        padding: { xs: "8px 4px", sm: "16px 12px" },
        borderBottom: "2px solid rgba(224, 224, 224, 0.8)",
        transition: "background-color 0.2s ease"
      }
    },
    children: [
      /* @__PURE__ */ jsx8(
        TableCell4,
        {
          align: "center",
          sx: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 4,
            bgcolor: "alternate.main",
            borderRight: `1px solid ${BORDER_COLOR}`,
            boxShadow: STICKY_SHADOW_LEFT
          },
          sortDirection: orderBy === "PartNumber" ? order : false,
          children: /* @__PURE__ */ jsx8(
            TableSortLabel,
            {
              active: orderBy === "PartNumber",
              direction: orderBy === "PartNumber" ? order : "asc",
              onClick: () => onSortRequest("PartNumber"),
              sx: sortLabelSx,
              children: /* @__PURE__ */ jsx8(
                Typography7,
                {
                  variant: "caption",
                  fontWeight: 700,
                  sx: {
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                    whiteSpace: "nowrap"
                  },
                  children: "Part Number"
                }
              )
            }
          )
        }
      ),
      visibleColumns.map((column) => /* @__PURE__ */ jsx8(
        TableCell4,
        {
          align: "center",
          sx: {
            position: "sticky",
            top: 0,
            zIndex: 3,
            bgcolor: "alternate.main",
            borderRight: `1px solid ${BORDER_COLOR}`,
            maxWidth: compact ? ADVANCED_COLUMN_MAX_WIDTH : { xs: 100, sm: 140 }
          },
          sortDirection: orderBy === column.name ? order : false,
          children: /* @__PURE__ */ jsx8(
            TableSortLabel,
            {
              active: orderBy === column.name,
              direction: orderBy === column.name ? order : "asc",
              onClick: () => onSortRequest(column.name),
              sx: sortLabelSx,
              children: /* @__PURE__ */ jsx8(
                Typography7,
                {
                  variant: "caption",
                  fontWeight: 700,
                  sx: {
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                    whiteSpace: "normal",
                    overflowWrap: "anywhere"
                  },
                  children: renderFilterName2(column.name)
                }
              )
            }
          )
        },
        column.name
      )),
      showDocsColumn && /* @__PURE__ */ jsx8(
        TableCell4,
        {
          align: "center",
          sx: {
            position: "sticky",
            top: 0,
            zIndex: 3,
            bgcolor: "alternate.main",
            borderRight: `1px solid ${BORDER_COLOR}`
          },
          children: /* @__PURE__ */ jsx8(
            Typography7,
            {
              variant: "caption",
              fontWeight: 700,
              sx: {
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                fontSize: { xs: "0.65rem", sm: "0.75rem" },
                whiteSpace: "nowrap"
              },
              children: "Docs"
            }
          )
        }
      ),
      /* @__PURE__ */ jsx8(
        TableCell4,
        {
          sx: {
            position: "sticky",
            right: 0,
            top: 0,
            zIndex: 4,
            bgcolor: "alternate.main",
            borderLeft: `1px solid ${BORDER_COLOR}`,
            boxShadow: STICKY_SHADOW_RIGHT
          }
        }
      )
    ]
  }
) });
var ProductsTableHead_default = ProductsTableHead;

// src/ProductsTable/useAdvancedViewPreference.ts
import { useEffect, useState } from "react";
var STORAGE_KEY = "advancedProductView";
var useAdvancedViewPreference = () => {
  const [isAdvanced, setIsAdvanced] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "true"
  );
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isAdvanced));
  }, [isAdvanced]);
  return [isAdvanced, setIsAdvanced];
};

// src/ProductsTable/useAutoNavigateToItem.ts
import { useEffect as useEffect2, useRef, useState as useState2 } from "react";
var useAutoNavigateToItem = (itemcode, sortedData, rowsPerPage, setPage, setExpandedRow) => {
  const [highlightedItemcode, setHighlightedItemcode] = useState2(null);
  const processedItemcodeRef = useRef(null);
  useEffect2(() => {
    if (itemcode && itemcode !== processedItemcodeRef.current && sortedData.length > 0) {
      const itemIndex = sortedData.findIndex(
        (item) => item.itemcode === itemcode
      );
      if (itemIndex !== -1) {
        const targetPage = Math.floor(itemIndex / rowsPerPage);
        const rowIndexInPage = itemIndex % rowsPerPage;
        setPage(targetPage);
        setExpandedRow(rowIndexInPage);
        setHighlightedItemcode(itemcode);
        processedItemcodeRef.current = itemcode;
      }
    } else if (!itemcode && processedItemcodeRef.current) {
      setExpandedRow(null);
      setHighlightedItemcode(null);
      processedItemcodeRef.current = null;
    }
  }, [itemcode, sortedData, rowsPerPage]);
  return { highlightedItemcode };
};

// src/ProductsTable/useBasket.ts
import { useEffect as useEffect3, useState as useState3 } from "react";
var useBasket = (columns) => {
  const [basket, setBasket] = useState3(getBasketFromLocalStorage());
  const [addedSnackbarOpen, setAddedSnackbarOpen] = useState3(false);
  useEffect3(() => {
    saveBasketToLocalStorage(basket);
  }, [basket]);
  const closeAddedSnackbar = () => setAddedSnackbarOpen(false);
  const handleToggleQuote = (item, event) => {
    event.stopPropagation();
    const itemCode = item.itemcode;
    setBasket((prevBasket) => {
      const newBasket = { ...prevBasket };
      if (newBasket[itemCode]) {
        delete newBasket[itemCode];
      } else {
        const params = getItemParams(item);
        const details = params.ParametersUI ?? {};
        const description = params.Description;
        const selectedDetails = {};
        (columns ?? []).filter((col) => col.isMain).forEach((col) => {
          selectedDetails[col.name] = details[col.name];
        });
        newBasket[itemCode] = {
          itemCode,
          details: selectedDetails,
          description
        };
        setAddedSnackbarOpen(true);
      }
      saveBasketToLocalStorage(newBasket);
      const basketEvent = new CustomEvent("basketChange", {
        detail: newBasket
      });
      window.dispatchEvent(basketEvent);
      return newBasket;
    });
  };
  return { basket, handleToggleQuote, addedSnackbarOpen, closeAddedSnackbar };
};

// src/ProductsTable/useTableSort.ts
import { useMemo, useState as useState4 } from "react";
var useTableSort = (filteredData, columns) => {
  const [order, setOrder] = useState4("asc");
  const [orderBy, setOrderBy] = useState4("");
  const handleSortRequest = (columnName) => {
    const isAsc = orderBy === columnName && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnName);
  };
  const applyMultiplier = (value, column) => {
    const multiplier = column?.multipler || 1;
    return parseFloat(String(value)) * multiplier;
  };
  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      if (!orderBy) return 0;
      let rawA, rawB;
      if (orderBy === "PartNumber") {
        rawA = getItemParams(a).PartNumber;
        rawB = getItemParams(b).PartNumber;
      } else {
        rawA = getItemParams(a).ParametersUI?.[orderBy];
        rawB = getItemParams(b).ParametersUI?.[orderBy];
      }
      const column = columns?.find((col) => col.name === orderBy);
      if (column && column.multipler !== null && column.multipler !== void 0) {
        const aValue = applyMultiplier(rawA || 0, column);
        const bValue = applyMultiplier(rawB || 0, column);
        return order === "asc" ? aValue - bValue : bValue - aValue;
      }
      const aText = (rawA ?? "").toString().toLowerCase();
      const bText = (rawB ?? "").toString().toLowerCase();
      return order === "asc" ? aText.localeCompare(bText, void 0, {
        numeric: true,
        sensitivity: "base"
      }) : bText.localeCompare(aText, void 0, {
        numeric: true,
        sensitivity: "base"
      });
    });
  }, [filteredData, order, orderBy, columns]);
  return { order, orderBy, handleSortRequest, sortedData };
};

// src/ProductsTable/useVisibleColumns.ts
import { useMemo as useMemo2 } from "react";
var isUsableValue = (raw) => {
  if (raw === void 0 || raw === null) return false;
  const str = String(raw).trim();
  return str !== "" && str !== "No data" && str !== "No Data";
};
var filterUsableColumns = (columns, filteredData) => columns.filter(
  (col) => filteredData.some(
    (item) => isUsableValue(getItemParams(item).ParametersUI?.[col.name])
  )
);
var useVisibleColumns = (columns, filteredData, mode) => useMemo2(() => {
  if (!columns || !filteredData) return [];
  return filterUsableColumns(
    columns.filter((col) => mode === "basic" ? col.isMain : true),
    filteredData
  );
}, [columns, filteredData, mode]);
var useAllUsableColumns = (columns, filteredData) => useMemo2(() => {
  if (!columns || !filteredData) return [];
  return filterUsableColumns(columns, filteredData);
}, [columns, filteredData]);

// src/ProductsTable/ProductsTable.tsx
import { Fragment as Fragment2, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var ProductsTable = ({
  columns,
  filteredData,
  itemcode = null
}) => {
  const theme = useTheme();
  const params = useParams();
  const tableContainerRef = useRef2(null);
  const [isAdvanced, setIsAdvanced] = useAdvancedViewPreference();
  const mode = isAdvanced ? "advanced" : "basic";
  const [page, setPage] = useState5(0);
  const [rowsPerPage, setRowsPerPage] = useState5(10);
  const [expandedRow, setExpandedRow] = useState5(null);
  const { basket, handleToggleQuote, addedSnackbarOpen, closeAddedSnackbar } = useBasket(columns);
  const { order, orderBy, handleSortRequest, sortedData } = useTableSort(
    filteredData,
    columns
  );
  const visibleColumns = useVisibleColumns(columns, filteredData, mode);
  const detailColumns = useAllUsableColumns(columns, filteredData);
  const { highlightedItemcode } = useAutoNavigateToItem(
    itemcode,
    sortedData,
    rowsPerPage,
    setPage,
    setExpandedRow
  );
  useEffect4(() => {
    if (filteredData.length > 0 && page * rowsPerPage >= filteredData.length) {
      setPage(0);
    }
  }, [filteredData, rowsPerPage]);
  const handleRowClick = (rowIndex) => {
    setExpandedRow((current) => current === rowIndex ? null : rowIndex);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    tableContainerRef.current?.scrollTo({ top: 0, behavior: "auto" });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const getShareUrl = (item) => {
    const categoryName = params.name;
    if (!categoryName) return window.location.href;
    const productUrl = generateProductItemUrl(categoryName, item.itemcode);
    return `${window.location.origin}${productUrl}`;
  };
  if (!columns || columns.length === 0 || !filteredData) {
    return null;
  }
  const pageRows = sortedData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return /* @__PURE__ */ jsxs8(Fragment2, { children: [
    /* @__PURE__ */ jsxs8(Helmet, { children: [
      /* @__PURE__ */ jsx9("title", { children: "Products - Our Offerings" }),
      /* @__PURE__ */ jsx9(
        "meta",
        {
          name: "description",
          content: "Browse our extensive list of products. Click on any product to see more details and add it to your quote list."
        }
      )
    ] }),
    /* @__PURE__ */ jsx9(AdvancedViewToggle_default, { checked: isAdvanced, onChange: setIsAdvanced }),
    visibleColumns.length > 2 && /* @__PURE__ */ jsx9(
      Box8,
      {
        sx: {
          display: { xs: "flex", sm: "none" },
          alignItems: "center",
          gap: 0.5,
          mb: 1
        },
        children: /* @__PURE__ */ jsx9(Typography8, { variant: "caption", color: "text.secondary", children: "Swipe left/right to see more specifications \u2192" })
      }
    ),
    /* @__PURE__ */ jsx9(
      TableContainer,
      {
        ref: tableContainerRef,
        component: Paper,
        sx: {
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          overflow: "auto",
          maxHeight: { xs: "65vh", sm: "70vh" },
          "& .MuiTable-root": {
            borderCollapse: "separate",
            borderSpacing: "0"
          }
        },
        children: /* @__PURE__ */ jsxs8(
          Table,
          {
            sx: {
              minWidth: { xs: "100%", sm: 750 },
              "& .MuiTableCell-root": {
                padding: mode === "advanced" ? { xs: "4px 3px", sm: "8px 8px" } : { xs: "8px 4px", sm: "16px 12px" },
                fontSize: { xs: "0.75rem", sm: "0.875rem" }
              },
              ...mode === "advanced" && {
                "& .MuiTableCell-root:first-of-type": {
                  padding: { xs: "4px 2px", sm: "8px 4px" }
                }
              }
            },
            "aria-label": "Product Table",
            children: [
              /* @__PURE__ */ jsx9(
                ProductsTableHead_default,
                {
                  visibleColumns,
                  order,
                  orderBy,
                  onSortRequest: handleSortRequest,
                  showDocsColumn: mode === "advanced",
                  compact: mode === "advanced"
                }
              ),
              /* @__PURE__ */ jsx9(TableBody, { children: pageRows.map(
                (item, i) => mode === "basic" ? /* @__PURE__ */ jsx9(
                  BasicRow_default,
                  {
                    item,
                    rowIndex: i,
                    visibleColumns,
                    detailColumns,
                    basket,
                    isExpanded: expandedRow === i,
                    onRowClick: handleRowClick,
                    onToggleQuote: handleToggleQuote,
                    getShareUrl
                  },
                  item.itemcode
                ) : /* @__PURE__ */ jsx9(
                  AdvancedRow_default,
                  {
                    item,
                    visibleColumns,
                    basket,
                    isHighlighted: item.itemcode === highlightedItemcode,
                    onToggleQuote: handleToggleQuote,
                    getShareUrl
                  },
                  item.itemcode
                )
              ) })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx9(
      TablePagination,
      {
        rowsPerPageOptions: [10, 25, 50],
        component: "div",
        count: filteredData.length,
        rowsPerPage,
        page,
        onPageChange: handleChangePage,
        onRowsPerPageChange: handleChangeRowsPerPage,
        sx: {
          borderTop: "1px solid rgba(224, 224, 224, 0.4)",
          ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows": {
            fontSize: { xs: "0.75rem", sm: "0.875rem" },
            color: "text.secondary",
            fontWeight: 500
          },
          ".MuiTablePagination-toolbar": {
            paddingLeft: { xs: "8px", sm: "16px" },
            paddingRight: { xs: "8px", sm: "16px" }
          }
        }
      }
    ),
    /* @__PURE__ */ jsx9(
      Snackbar,
      {
        open: addedSnackbarOpen,
        autoHideDuration: 2500,
        onClose: closeAddedSnackbar,
        anchorOrigin: { vertical: "top", horizontal: "center" },
        disableWindowBlurListener: true,
        sx: {
          "& .MuiSnackbarContent-root": {
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.9
            },
            zIndex: 1e3,
            pointerEvents: "auto"
          },
          zIndex: 1e3,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ jsx9(
          Alert,
          {
            onClose: closeAddedSnackbar,
            severity: "success",
            sx: {
              width: "100%",
              marginTop: "80px",
              cursor: "pointer",
              "& .MuiAlert-message": {
                fontSize: "0.9rem",
                fontWeight: 500
              },
              pointerEvents: "auto"
            },
            onClick: closeAddedSnackbar,
            children: 'We added item to the quote, please click "Send Inquiry" when you ready to proceed!'
          }
        )
      }
    )
  ] });
};
var ProductsTable_default = ProductsTable;
export {
  ProductsTable_default as ProductsTable
};
